module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2008ef9a82bcbaa0dd5fb3fa121c4afc.png";